import PropTypes from "prop-types";
import "./QuotationRoom.scss";
import QuotationRoomBody from "./QuotationRoomBody";
import QuotationRoomLabel from "./QuotationRoomLabel";

const QuotationRoom = ({ accommodation = {}, onBoardChange, selectedAccommmodationCode }) => {
	const rooms = accommodation?.items?.map(
		({
			quantity,
			description,
			label,
			area,
			adults,
			children,
			infants,
			amenities,
			accommodationItemCode,
			photos,
		}) => ({
			id: accommodationItemCode,
			quantity,
			description,
			title: label,
			amenities: amenities?.map(item => item?.label) || [],
			photos: photos || [],
			area: {
				value: area?.value || 0,
				unit: area?.unit || "m²",
			},
			occupancy: { adults, children, babies: infants },
		})
	);

	const isSelected = accommodation.code === selectedAccommmodationCode;

	const handleBoardChange = board => {
		if (onBoardChange) {
			onBoardChange(board, accommodation);
		}
	};

	return (
		<div
			className={`quotation-room ${isSelected ? "quotation-room--selected" : ""}`}
			data-testid={`quotation-rooms-${accommodation.code}`}
			aria-selected={isSelected ? "true" : ""}
		>
			<QuotationRoomLabel rooms={rooms} />
			<QuotationRoomBody
				accommodationUpgradePrice={accommodation?.upgradePrice}
				isAccommodationIncluded={accommodation?.included}
				boards={accommodation?.boards}
				rooms={rooms}
				onBoardChange={handleBoardChange}
			/>
		</div>
	);
};

QuotationRoom.propTypes = {
	accommodation: PropTypes.object,
	onBoardChange: PropTypes.func,
	selectedAccommmodationCode: PropTypes.object,
};

export default QuotationRoom;
